var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ig",
    transform: "translate(174.000000, 0.000000)"
  }, "\n          {\" \"}\n          ", /*#__PURE__*/React.createElement("path", {
    id: "Fill-120-Copy",
    fill: "#181818",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-174,8.4c0-4.6,3.8-8.4,8.4-8.4h15.3c4.6,0,8.4,3.8,8.4,8.4l0,15.3c0,4.6-3.8,8.4-8.4,8.4   h-15.3c-4.6,0-8.4-3.8-8.4-8.4V8.4z"
  }), "{\" \"}\n          ", /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-166.9,8.2l1.7,2.1v10.2l-2.5,3.3h5.9l-2.5-3.3v-9.1l5.5,12.3l0,0l5.1-12.4v10.7l-1.7,1.7h7.2l-1.7-1.7l0-12   l1.6-1.9h-5.1l-3.9,9.6l-4.3-9.6H-166.9z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.b8e09a8f8ac96de5a748ace83f6782e0.svg";
export { ForwardRef as ReactComponent };